import React, { useMemo } from "react";
import "./SocialMedia.css";

const Instagram = ({ instagramLink }) => {
  const embedUrl = useMemo(
    () => `${instagramLink.replace(/\/+$/, "")}/embed`,
    [instagramLink]
  );

  return (
    <div className="social-media-container">
      <h3 className="social-media-title">Follow us on Instagram</h3>
      <div className="social-media-frameWrap">
        <iframe
          title="Instagram profile"
          className="social-media-iframe"
          src={embedUrl}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
          scrolling="no"
        />
      </div>
    </div>
  );
};

export default Instagram;
